import CookieConsents from 'utils/cookieConsents'


export default function isCookiePolicyVersionUpdated(cookiePolicy) {
  const consents = CookieConsents.getConsents() || {}
  const consentedDocumentVersion = consents.document_version_id || 0

  return ( cookiePolicy.published_document_version_id > consentedDocumentVersion )
}
